<template>
    <div class="doc-section">
        <h1>Dispositivos a la Redonda</h1>
        <p>
            Esta funcionalidad permite localizar otros dispositivos que se encuentren dentro de un radio de proximidad
            específico a partir de un dispositivo seleccionado.
        </p>

        <plataformaNavegacion @cambio-plataforma="actualizarVista" />


        <h2>Proceso de Búsqueda</h2>
        <ul class="ul-contenedor step-list ">
            <li>Ubique el dispositivo de origen en la tabla y haga clic en el icono de <strong>Dispositivos a la
                    redonda</strong></li>
            <li>Se desplegará un <strong>formulario de configuración</strong> donde deberá establecer los parámetros de
                búsqueda.</li>
            <li>Haga clic en el botón de búsqueda para proyectar los resultados sobre el mapa.</li>
        </ul>

        <h2>Configuración del Radio</h2>
        <p>Dentro del formulario, podrá definir:</p>
        <ul class="ul-contenedor step-list ">
            <li><strong>Distancia:</strong> El valor numérico del radio de búsqueda.</li>
            <li><strong>Unidad de medida:</strong> Selección entre <strong>Metros</strong> o <strong>Kilómetros</strong>
                según la precisión requerida.</li>
        </ul>

        <div class="card">
            <p>
                <strong>Resultado:</strong> Una vez ejecutada la acción, el mapa mostrará marcadores adicionales para
                todos los dispositivos que se encuentren dentro del rango establecido, facilitando la gestión de flotas
                cercanas.
            </p>
        </div>

        <h3>Referencia visual</h3>
        <div v-if="plataforma === 'web'" class="platform-content">
            <CarruselAciqui :items="imagenesRedonda" />
        </div>
        <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="imagenesRedondaMoviles" />
        </div>


    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'DispositivosRedonda',
    components: { CarruselAciqui, plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        imagenesRedonda: [
            {
                nombre: "Formulario de Búsqueda",
                url: "img/monitoreo/formularioRedonda.png",
                descripcion: "Interfaz para ingresar el radio y unidades de medida."
            },
            {
                nombre: "Resultados en Mapa",
                url: "img/monitoreo/DispRedonda.png",
                descripcion: "Visualización de los dispositivos cercanas tras aplicar el filtro."
            }
        ],
        imagenesRedondaMoviles: [
            {
                nombre: "Formulario de Búsqueda",
                url: "img/monitoreo/moviles/formularioRedonda.png",
                descripcion: "Interfaz para ingresar el radio y unidades de medida."
            },
            {
                nombre: "Resultados en Mapa",
                url: "img/monitoreo/moviles/DispRedonda.png",
                descripcion: "Visualización de los dispositivos cercanas tras aplicar el filtro."
            }
        ]
    }),
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>